import anime from "animejs/lib/anime.es";
import imagesLoaded from "imagesloaded/imagesloaded.pkgd";

{
    class Details {
        constructor() {
            this.DOM = {};

            const detailsTmpl = `
            <div class="details__bg details__bg--up"></div>
            <div class="details__bg details__bg--down"></div>
            <div class="circle-img">
                <img class="details__img" src="" alt="img 01"/>
            </div>
            <h3 class="details__title"></h3>
            <p class="details__description"></p>
            <div class="details__circles">
                <div class="modal-circles--single"></div>
                <div class="modal-circles--single"></div>
                <div class="modal-circles--single"></div>
                <div class="modal-circles--single"></div>
                <div class="modal-circles--single"></div>
                <div class="modal-circles--single"></div>
            </div>
            <span class="details__close">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.99974 5.58599L11.9497 0.635986L13.3637 2.04999L8.41374 6.99999L13.3637 11.95L11.9497 13.364L6.99974 8.41399L2.04974 13.364L0.635742 11.95L5.58574 6.99999L0.635742 2.04999L2.04974 0.635986L6.99974 5.58599Z" fill="#314855"/>
                </svg>
                close
            </span>
            `;

            this.DOM.details = document.createElement('div');
            this.DOM.details.className = 'details';
            this.DOM.details.innerHTML = detailsTmpl;
            DOM.content.appendChild(this.DOM.details);
            this.init();
        }

        init() {
            this.DOM.bgUp = this.DOM.details.querySelector('.details__bg--up');
            this.DOM.bgDown = this.DOM.details.querySelector('.details__bg--down');
            this.DOM.img = this.DOM.details.querySelector('.details__img');
            this.DOM.title = this.DOM.details.querySelector('.details__title');
            this.DOM.circles = this.DOM.details.querySelector('.details__circles');
            this.DOM.singleCircle = this.DOM.details.querySelector('.modal-circles--single');
            this.DOM.circleImage = this.DOM.details.querySelector('.details__circles img');
            this.DOM.description = this.DOM.details.querySelector('.details__description');
            this.DOM.close = this.DOM.details.querySelector('.details__close');
            this.initEvents();
        }

        initEvents() {
            this.DOM.close.addEventListener('click', () => this.isZoomed ? this.zoomOut() : this.close());
        }

        fill(info) {
            this.DOM.img.src = info.img;
            this.DOM.circleImage = info.circleImage;
            this.DOM.title.innerHTML = info.title;
            this.DOM.circles.innerHTML = info.modalCircles;
            this.DOM.description.innerHTML = info.description;
        }

        getModalDetailsRect() {
            return {
                modalBgRect: this.DOM.bgUp.getBoundingClientRect(),
                detailsBgRect: this.DOM.bgDown.getBoundingClientRect(),
                modalImgRect: this.DOM.graphicImg.getBoundingClientRect(),
                detailsImgRect: this.DOM.img.getBoundingClientRect()
            };
        }

        open(data) {
            if (this.isAnimating) return false;
            this.isAnimating = true;

            this.DOM.details.classList.add('details--open');

            this.DOM.graphicImg = data.graphicImg;

            this.DOM.graphicImg.style.opacity = 0;

            const rect = this.getModalDetailsRect();

            this.DOM.bgDown.style.transform = `translateX(${rect.modalBgRect.left - rect.detailsBgRect.left}px) translateY(${rect.modalBgRect.top - rect.detailsBgRect.top}px) scaleX(${rect.modalBgRect.width / rect.detailsBgRect.width}) scaleY(${rect.modalBgRect.height / rect.detailsBgRect.height})`;
            this.DOM.bgDown.style.opacity = 1;

            this.DOM.img.style.transform = `translateX(${rect.modalImgRect.left - rect.detailsImgRect.left}px) translateY(${rect.modalImgRect.top - rect.detailsImgRect.top}px) scaleX(${rect.modalImgRect.width / rect.detailsImgRect.width}) scaleY(${rect.modalImgRect.height / rect.detailsImgRect.height})`;
            this.DOM.img.style.opacity = 1;

            this.DOM.circles.classList.add('circle-load');

            anime({
                targets: [this.DOM.bgDown, this.DOM.img],
                duration: (target, index) => index ? 250 : 250,
                easing: (target, index) => index ? 'easeOutSine' : 'easeOutSine',
                elasticity: 250,
                translateX: 0,
                translateY: 0,
                scaleX: 1,
                scaleY: 1,
                complete: () => this.isAnimating = false
            });

            anime({
                targets: [this.DOM.title, this.DOM.circles, this.DOM.description],
                duration: 600,
                easing: 'easeOutExpo',
                delay: (target, index) => {
                    return index * 60;
                },
                translateY: (target, index, total) => {
                    return index !== total - 1 ? [50, 0] : 0;
                },
                scale: (target, index, total) => {
                    return index === total - 1 ? [0, 1] : 1;
                },
                opacity: 1
            });

            anime({
                targets: this.DOM.bgUp,
                duration: 100,
                easing: 'linear',
                opacity: 1
            });

            anime({
                targets: this.DOM.close,
                duration: 250,
                easing: 'easeOutSine',
                translateY: ['100%', 0],
                opacity: 1
            });
        }

        close() {
            if (this.isAnimating) return false;
            this.isAnimating = true;

            this.DOM.details.classList.remove('details--open');
            this.DOM.circles.classList.remove('circle-load');

            anime({
                targets: this.DOM.close,
                duration: 250,
                easing: 'easeOutSine',
                translateY: '100%',
                opacity: 0
            });

            anime({
                targets: this.DOM.bgUp,
                duration: 100,
                easing: 'linear',
                opacity: 0
            });

            anime({
                targets: [this.DOM.title, this.DOM.circles, this.DOM.description],
                duration: 20,
                easing: 'linear',
                opacity: 0
            });

            const rect = this.getModalDetailsRect();

            anime({
                targets: [this.DOM.bgDown, this.DOM.img],
                duration: 250,
                easing: 'easeOutSine',
                translateX: (target, index) => {
                    return index ? rect.modalImgRect.left - rect.detailsImgRect.left : rect.modalBgRect.left - rect.detailsBgRect.left;
                },
                translateY: (target, index) => {
                    return index ? rect.modalImgRect.top - rect.detailsImgRect.top : rect.modalBgRect.top - rect.detailsBgRect.top;
                },
                scaleX: (target, index) => {
                    return index ? rect.modalImgRect.width / rect.detailsImgRect.width : rect.modalBgRect.width / rect.detailsBgRect.width;
                },
                scaleY: (target, index) => {
                    return index ? rect.modalImgRect.height / rect.detailsImgRect.height : rect.modalBgRect.height / rect.detailsBgRect.height;
                },
                complete: () => {
                    this.DOM.bgDown.style.opacity = 0;
                    this.DOM.img.style.opacity = 0;
                    this.DOM.bgDown.style.transform = 'none';
                    this.DOM.img.style.transform = 'none';
                    this.DOM.graphicImg.style.opacity = 1;
                    this.isAnimating = false;
                }
            });
        }

        zoomIn() {
            this.isZoomed = true;

            anime({
                targets: [this.DOM.title, this.DOM.circles, this.DOM.description],
                duration: 100,
                easing: 'easeOutSine',
                translateY: (target, index, total) => {
                    return index !== total - 1 ? [0, index === 0 || index === 1 ? -50 : 50] : 0;
                },
                scale: (target, index, total) => {
                    return index === total - 1 ? [1, 0] : 1;
                },
                opacity: 0
            });

            const imgrect = this.DOM.img.getBoundingClientRect();
            const win = { w: window.innerWidth, h: window.innerHeight };

            const imgAnimeOpts = {
                targets: this.DOM.img,
                duration: 250,
                easing: 'easeOutCubic',
                translateX: win.w / 2 - (imgrect.left + imgrect.width / 2),
                translateY: win.h / 2 - (imgrect.top + imgrect.height / 2)
            };

            if (win.w > 0.8 * win.h) {
                this.DOM.img.style.transformOrigin = '50% 50%';
                Object.assign(imgAnimeOpts, {
                    scaleX: 0.95 * win.w / parseInt(0.8 * win.h),
                    scaleY: 0.95 * win.w / parseInt(0.8 * win.h),
                    rotate: 90
                });
            }

            anime(imgAnimeOpts);

            anime({
                targets: this.DOM.close,
                duration: 250,
                easing: 'easeInOutCubic',
                scale: 1.8,
                rotate: 180
            });
        }

        zoomOut() {
            if (this.isAnimating) return false;
            this.isAnimating = true;
            this.isZoomed = false;

            anime({
                targets: [this.DOM.title, this.DOM.circles, this.DOM.description],
                duration: 250,
                easing: 'easeOutCubic',
                translateY: 0,
                scale: 1,
                opacity: 1
            });

            anime({
                targets: this.DOM.img,
                duration: 250,
                easing: 'easeOutCubic',
                translateX: 0,
                translateY: 0,
                scaleX: 1,
                scaleY: 1,
                rotate: 0,
                complete: () => {
                    this.DOM.img.style.transformOrigin = '0 0';
                    this.isAnimating = false;
                }
            });

            anime({
                targets: this.DOM.close,
                duration: 250,
                easing: 'easeInOutCubic',
                scale: 1,
                rotate: 0
            });
        }
    };

    class Item {
        constructor(el) {
            this.DOM = {};
            this.DOM.el = el;
            this.DOM.circles = this.DOM.el.querySelector('.circles');
            this.DOM.modal = this.DOM.el.querySelector('.modal-content');
            this.DOM.graphicImg = this.DOM.circles.querySelector('.graphic-image');

            this.info = {
                img: this.DOM.graphicImg.src,
                title: this.DOM.modal.querySelector('.modal-title').innerHTML,
                description: this.DOM.circles.querySelector('.modal-description').innerHTML,
                modalCircles: this.DOM.circles.querySelector('.modal-circles').innerHTML
            };

            this.initEvents();
        }
        initEvents() {
            this.DOM.circles.addEventListener('click', () => this.open());
        }
        open() {
            DOM.details.fill(this.info);
            DOM.details.open({
                graphicImg: this.DOM.graphicImg
            });
        }
    };

    const DOM = {};
    DOM.grid = document.querySelector('.interactive-solutions');
    DOM.content = DOM.grid.parentNode;
    DOM.gridItems = Array.from(DOM.grid.querySelectorAll('.grid-items'));
    let items = [];
    DOM.gridItems.forEach(item => items.push(new Item(item)));

    DOM.details = new Details();

    imagesLoaded(document.body, () => document.body.classList.remove('loading'));
};


const circles = document.querySelectorAll('.circle');

circles.forEach(function (circle) {
    circle.addEventListener('click', e => {
        document.body.classList.add('no-scroll');
        document.querySelector('.interactive-solutions--graphic').classList.add('zoom-active');
    })
})

const close = document.querySelector('.details__close');

close.addEventListener('click', e => {
    document.body.classList.remove('no-scroll');
    document.querySelector('.interactive-solutions--graphic').classList.remove('zoom-active');
})